<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Thomas Jefferson</title>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<link href="thomasjefferson.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="contents" id="con">
<a id="page10"></a>
<a id="page11"></a>
<h2 class="contentsHead"><i>Contents</i></h2>
<div class="contentsEntry1" id="ded_01"><span href="#/thomasjefferson_ded#ded01" title="Link target outside of Sample">Dedication</span></div>
<div class="contentsEntry1" id="ack_01"><a href="#/thomasjefferson_ack01#ack01">Acknowledgments</a></div>
<div class="contentsEntry1" id="int_01"><a href="#/thomasjefferson_int01#int01">Introduction</a></div>
<div class="contentsEntry" id="ch_01"><a href="#/thomasjefferson_ch01#ch01">Chapter One: All Politics Is Local: Virginia to Philadelphia</a></div>
<div class="contentsEntry" id="ch_02"><span href="#/thomasjefferson_ch02#ch02" title="Link target outside of Sample">Chapter Two: War and Revolution in Virginia</span></div>
<div class="contentsEntry" id="ch_03"><span href="#/thomasjefferson_ch03#ch03" title="Link target outside of Sample">Chapter Three: Revolution in France (and a Meeting with Sally)</span></div>
<div class="contentsEntry" id="ch_04"><span href="#/thomasjefferson_ch04#ch04" title="Link target outside of Sample">Chapter Four: Interregnum</span></div>
<div class="contentsEntry" id="ch_05"><span href="#/thomasjefferson_ch05#ch05" title="Link target outside of Sample">Chapter Five: Secretary of State</span></div>
<div class="contentsEntry" id="ch_06"><span href="#/thomasjefferson_ch06#ch06" title="Link target outside of Sample">Chapter Six: In Waiting</span></div>
<div class="contentsEntry" id="ch_07"><span href="#/thomasjefferson_ch07#ch07" title="Link target outside of Sample">Chapter Seven: Mr. President</span></div>
<div class="contentsEntry" id="ch_08"><span href="#/thomasjefferson_ch08#ch08" title="Link target outside of Sample">Chapter Eight: Disappointment: The Second Term</span></div>
<div class="contentsEntry" id="ch_09"><span href="#/thomasjefferson_ch09#ch09" title="Link target outside of Sample">Chapter Nine: Declining Years</span></div>
<div class="contentsEntry1" id="ata_01"><span href="#/thomasjefferson_ata01#ata01" title="Link target outside of Sample">About the Author</span></div>
<div class="contentsEntry1" id="adc_01"><span href="#/thomasjefferson_adc01#adc01" title="Link target outside of Sample">Books in the Eminent Lives Series</span></div>
<div class="contentsEntry1" id="adc_02"><span href="#/thomasjefferson_adc02#adc02" title="Link target outside of Sample">Also by Christopher Hitchens</span></div>
<div class="contentsEntry1" id="cre_01"><span href="#/thomasjefferson_cre01#cre01" title="Link target outside of Sample">Credits</span></div>
<div class="contentsEntry1" id="cop_01"><span href="#/thomasjefferson_cop01#cop01" title="Link target outside of Sample">Copyright</span></div>
<div class="contentsEntry1" id="atp_01"><span href="#/thomasjefferson_atp01#atp01" title="Link target outside of Sample">About the Publisher</span>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// thomasjefferson_con.vue?6e8ca1ef